<div class="sync-competitor-article">
  <mat-checkbox
    class="sync-competitor-article-checkbox"
    [checked]="isSelected()"
    (change)="handleUpdateChecked($event.checked)"
  />
  <div class="sync-competitor-article-id">
    Id: {{ competitorArticle().id }}
  </div>
  <div class="sync-competitor-article-title">
    {{ competitorArticle().productTitle || 'Название не задано' }}
  </div>
  <div class="sync-competitor-article-params">
    @for (param of competitorArticleParamsData; track $index) {
      <div class="sync-competitor-article-param">
        <div class="sync-competitor-article-param-label">
          {{ param.label }}:
        </div>
        <div class="sync-competitor-article-param-value">
          {{ getParamData(param.fieldName) }}
        </div>
      </div>
    }
  </div>
  <div class="buttons-container">
    <a
      mat-button
      class="save-button"
      target="_blank"
      [href]="competitorArticle().url"
    >
      <mat-icon>
        share
      </mat-icon>
      Открыть
    </a>
  </div>
</div>
